
import Vue from 'vue';

export default Vue.extend({
	name: 'BannerGridOverlay',
	props: {
		gridColor: {
			type: String,
			default: '#555',
		},
		width: {
			type: Number,
			default: 1200,
		},
		height: {
			type: Number,
			default: 160,
		},
	},
	data () {
		return {
			uniqueId: Math.random().toString(36).substr(2, 9), // Generate unique ID for pattern
		};
	},
});
